module.exports = __webpack_public_path__ + "img/download.20cb1591.svg";